module.exports = {
  // baseURL:'https://test.xm888.app/Home' //测试环境
  baseURL:'https://www.mengmazb.com/Home'

}
